
import { OverlayData } from "../ui/overlay/Overlay";
import BaseEvent from "./BaseEvent";

export default class OverlayEvent extends BaseEvent{
    data?:OverlayData;


    static SHOW:string = "show";
    static HIDE:string = "hide";
}